<div id="body" fxLayout="column" fxFlexFill [ngStyle]="{'max-height.px': innerHeight}" class="layout-padd">
    <!-- <div id="body" fxLayout="column" fxFlexFill  class="layout-padd"> -->
    <!-- <div id="body" fxLayout="column" fxFlexFill [ngStyle]="{'height.px': innerHeight,'width.px': innerWidth}" class="layout-padd"
    > -->

    <!-- title -->

    <div id="body-header" fxLayout="row" fxLayoutAlign="start center" style="height: 60px ">
        <img src="assets/img/refonte-logo/myPosLogo.jpg"  class="h-10">
        <span class="mat-subheading-1 boldest"
            style=" padding-left: 10px;">{{"endorder.online-payment"|translate}}</span>
    </div>

    <!-- content -->
    <div id="content" fxLayout="column" fxLayoutAlign="start center" [ngStyle]="{'height.px': heightColumn}">

        <!-- apple google  button pay -->
        <app-my-pos-embedded-buttons *ngIf="applegoogleButonVisible" class="full-w" [amount]="amount" [id_user]="id_user"
            [metadata_provenance]="metadata_provenance" [mypos_account]="mypos_account"
            (onSuccessEvent)="onSuccessAppleGoogle($event)"></app-my-pos-embedded-buttons>


        <form id="payment-form">

            <div id="embeddedCheckout" [class.isDisabled]="errorButton"></div>

            <app-popup-loader [flagLoading]="spinnerIsLoading" [size]="30" *ngIf="proccessing "></app-popup-loader>


            <div id="divButton" [class.error]="errorButton ||paymentInProcess || paymentSucceded"
                *ngIf="!spinnerIsLoading && FormButtonPayPmypos" fxLayout="row" fxLayoutAlign="center center">
                <button class="buttonMypos" mat-raised-button id="btn-pay" name="pay" fxFlex="100"
                    [disabled]="paymentInProcess ||errorButton || paymentSucceded" (click)="processPayment($event)">

                    <div class="spinner" id="spinner" *ngIf="paymentInProcess"></div>
                    <span id="button-text">{{"button.pay"|translate}}
                        {{amount|priceFilter:mypos_account.currency.symbol
                        }}
                    </span>
                </button>
            </div>
        </form>

    </div>


    <!-- footer -->
    <div id="body-footer" fxLayout="column" fxLayoutAlign="start center" style="height: 50px;padding-top:'10px'">


        <div fxLayout="row" class="full-w" fxLayoutAlign="center center"
            *ngIf="!spinnerIsLoading && FormButtonPayPmypos">
            <button mat-raised-button fxFlex="100" (click)="closeDial()" angulartics2On="click"
                angularticsAction="cancelPayPos" angularticsCategory="payPos"
                [disabled]="paymentInProcess">{{'cancel_button'|translate}}
            </button>
        </div>





        <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!spinnerIsLoading && !FormButtonPayPmypos ">

            <button mat-raised-button fxFlex="100" (click)="closeDial()" angulartics2On="click"
                angularticsAction="cancelPayPos" angularticsCategory="payPos">{{'cancel_button'|translate}}
            </button>


        </div>
    </div>


    <!-- content (innerHeight - title -footer) -->
    <!-- footer -->

    <!-- <div fxLayout="column" fxLayoutGap="10px" class="layout-padd" >

         <div>

            <div fxLayout="row" fxLayoutAlign="start center">
                <img src="assets/img/refonte-logo/myPosLogo.jpg" height="40">
                <span class="mat-subheading-1 boldest"
                    style=" padding-left: 10px;">{{"endorder.online-payment"|translate}}</span>
            </div>



        </div> -->



    <!--
        <div id="embeddedButtons"></div>
       <iframe name="IPCIFrame_1714397009806" id="IPCIFrame_1714397009806" role="presentation" allow="payment *" width="100%" scrolling="no" style="display: block; border: none; overflow: hidden; height: 40px; width: 100%;" src="https://mypos.com/vmp/checkout-test/googlePayIframe?sessionToken=eyJpbmZvIjoiMTQ5Mzk3Mi1WTUlDWEwtMS0xLUVVUi0xOS1mciIsImlkZW50aXR5IjoiUlVDdFJzTW5fMkxRUzdPbDdwOEVlYTZ1S0hDMlR6WURsS2k1ZzJfX250Smk1czN3RXg3Wjc0cUNfR0NBVFZZZjBzREhDekJQWUEtLSJ9&amp;configData=eyJpc1NhbmRib3giOnRydWV9" allowpaymentrequest="1"></iframe>
 -->



    <!-- <div id="content" fxLayout="column" class="stri ">

            <app-popup-loader [flagLoading]="spinnerIsLoading" [size]="30"></app-popup-loader>


            <form id="payment-form">



                <div id="embeddedCheckout"></div>

                <app-popup-loader [flagLoading]="spinnerIsLoading" [size]="30" *ngIf="proccessing "></app-popup-loader>






                <div class="buttonFixedmypos" style="z-index: 99 !important;">
                    <div fxLayoutAlign="space-between" style="padding-top:'10px'" fxLayoutGap="10px"
                        *ngIf="!spinnerIsLoading && FormButtonPayPmypos">


                        <button mat-raised-button fxFlex="30" fxFlex.xs="50" (click)="closeDial()"
                            angulartics2On="click" angularticsAction="cancelPayPos" angularticsCategory="payPos"
                            [disabled]="paymentInProcess">{{'cancel_button'|translate}}
                        </button>




                        <button color="primary"  mat-raised-button id="btn-pay"  name="pay" fxFlex="30" fxFlex.xs="50"
                            [disabled]="paymentInProcess ||errorButton" (click)="processPayment($event)">

                            <div class="spinner" id="spinner" *ngIf="paymentInProcess"></div>
                            <span id="button-text">{{"button.pay"|translate}}
                                {{amount|priceFilter:mypos_account.currency.symbol
                               }}
                            </span>
                        </button>


                    </div>

                    <div fxLayoutAlign="center center" style="padding-top:'10px'" fxLayoutGap="10px"
                        *ngIf="!spinnerIsLoading && !FormButtonPayPmypos">


                        <button mat-raised-button fxFlex="500" fxFlex.xs="80" (click)="closeDial()"
                            angulartics2On="click" angularticsAction="cancelPayPos" angularticsCategory="payPos"
                           >{{'cancel_button'|translate}}
                        </button>


                    </div>
                </div>





            </form>

        </div> -->

    <!-- </div> -->

    <app-popup-loader style="z-index: 999999 !important;" [flagLoading]="spinnerPayIsLoading || startSpinner"
        [size]="30" [statusMessage]="statusMessage">
    </app-popup-loader>


</div>
